import { Component, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/API/auth.service';
import { HomeFieldService } from 'src/app/API/homefield.service';
import { AppComponent } from 'src/app/app.component';
import { ConfirmationDialog } from 'src/app/Core/ConfirmationDialog';
import { Globals } from 'src/app/globals';
import { SectionPrepdetailDialog } from 'src/app/HomeFieldService/Section/section-prepdetail/section-prepdetail.component';
import { Inject } from '@angular/core';
import { InvApiService } from 'src/app/API/invapi.service';
import { ContactApiService } from 'src/app/API/contactapi.service';

@Component({
  selector: 'QuantityManagementDialog',
  templateUrl: './QuantityManagementDialog.component.html',
  styleUrls: ['./QuantityManagementDialog.component.css']
})
export class QuantityManagementDialogComponent {
  matDialogRef: MatDialogRef<ConfirmationDialog>;
  isValidFormSubmitted = false;
  errormsg = "";
  totalQuantity: any;
  remainingQuantity: number = 0;
  showNewQty: boolean = false;
  unassignedQty: number = 0;

  partquantityForm = new UntypedFormGroup({
    PrepDate: new UntypedFormControl(''),
    CreatedOn: new UntypedFormControl(''),
    CreatedBy: new UntypedFormControl(''),
    CreatedByName: new UntypedFormControl(''),
    unassignedQty: new UntypedFormControl({ value: 0, disabled: true }),
    divisionParts: this.fb.array([]),
  });

  constructor(
    private auth: AuthService,
    private homefieldApi: HomeFieldService,
    private invapi: InvApiService,
    public dialogRef: MatDialogRef<SectionPrepdetailDialog>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private contactApi: ContactApiService,
    @Inject(MAT_DIALOG_DATA) public data: any) 
    { }

 
  today = new Date();
  UserName = this.auth.GetUserName();
  UserId = this.auth.GetUserId();
  displayList = false;
  DivisionList = [];
 
  ngOnInit() {
    this.auth.GetCurrentDateTimeFromServer().subscribe(currentDate => {
    this.today = new Date(currentDate);
    this.totalQuantity = this.data.quantity;
 
      AppComponent.HideLoader();
    }, error => {
      AppComponent.HideLoader();
    });
  }
 
  ngAfterViewInit() {
    this.initializeDivisions();
  }
  
   get divisionParts(): FormArray {
    return this.partquantityForm.get('divisionParts') as FormArray;
  }
 
  get prepf() {
    return this.partquantityForm?.controls ?? {};
  }

 initializeDivisions() {

  this.calculateRemainingQuantity();
  AppComponent.ShowLoader();

  const Id = { Id: this.data.equipementId };
   this.invapi.GetPartsQuantityByDivision(Id).subscribe(
      (success: any[]) => {
       if (success && success.length > 0) {
        this.divisionParts.clear();
        this.unassignedQty = 0; // reset

        success.forEach(item => {
          if (item.divisionID === 0) {
            this.partquantityForm.get('unassignedQty')?.setValue( item.qty);
          } else {
            this.divisionParts.push(
              this.fb.group({
                division: [item.divisionName],
                divisionID: [item.divisionID],
                quantity: [item.qty, [Validators.required, Validators.min(0)]],
                newQuantity: [0, [Validators.required, Validators.min(0)]],
              })
            );
          }
        });
        AppComponent.HideLoader();
      }
    else {
       this.contactApi.FillDivisionWithPrefix().subscribe(list => {
          this.DivisionList = list.filter(item => item.value !== '');
          this.divisionParts.clear();

          this.DivisionList.forEach(item => {
            this.divisionParts.push(
              this.fb.group({
                division: [item.text], 
                divisionID: [item.value], 
                quantity: [0, [Validators.required, Validators.min(0)]],
                newQuantity: [0, [Validators.required, Validators.min(0)]],
                selected: [false]
              })
            );
          });
    });
  }
        AppComponent.HideLoader();
        }, error => {
          AppComponent.addAlert(error.message || "Error fetching division list", 'error');
          AppComponent.HideLoader();
        });
        
        this.divisionParts.valueChanges.subscribe(() => {
        this.calculateRemainingQuantity();
    });
}

calculateRemainingQuantity() {
  const total = this.totalQuantity || 0;
  const used = this.divisionParts.controls.reduce((sum, group) => {
    const qty = group.get('quantity')?.value || 0;
    return sum + Number(qty);
  }, 0);

  this.remainingQuantity = total - used;
}

prepareCreateViewModel(Source = "") {
  const modelCreate: any = {};
  const now = new Date();

  const parts = this.divisionParts.controls.map(ctrl => ({
    divisionID: ctrl.get('divisionID')?.value,
    quantity: this.showNewQty ? ctrl.get('newQuantity')?.value : ctrl.get('quantity')?.value,
    createdOn: Globals.GetAPIDate(now),
    createdBy: this.UserId,
    modifiedOn: Globals.GetAPIDate(now),
    modifiedBy: this.UserId,
    partID: this.data.equipementId
  }));

   modelCreate.PartQuantities = parts;
  return modelCreate;
}
 
  onFormChanges(): void {
  }

  saveAndClose() {
    if (this.partquantityForm.dirty) {
      if (this.partquantityForm.invalid) {
        this.matDialogRef = this.dialog.open(ConfirmationDialog, {
          disableClose: true
        });
        this.matDialogRef.componentInstance.confirmMessage =
          'You have unsaved changes! If you leave, your changes will be lost.';
        this.matDialogRef.afterClosed().subscribe(result => {

          if (result)
            this.dialogRef.close(false);
          else
            this.save();
        });
      }
      else {
        this.save();
      }
    } else {
      this.dialogRef.close(false);
    }
  }

  save() {
  AppComponent.loading = true;
  this.isValidFormSubmitted = true;

  if (this.partquantityForm.invalid) {
    AppComponent.loading = false;
    return;
  }

  const partID = this.data?.equipementId || '0';
  // Always prepare data from form
  const prepCreate = this.prepareCreateViewModel();
  const inventoryCreate = this.data.inventoryCreate;
  
   if (inventoryCreate.equipementId == '0') {
    inventoryCreate.partQuantities = prepCreate.PartQuantities;
      this.invapi.CreateInventoryDetails(inventoryCreate).subscribe(
      (success) => {
          AppComponent.loading = false;
          AppComponent.addAlert('Data Saved successfully!', 'success');
          this.dialogRef.close(success.equipementId);
          AppComponent.HideLoader();
        },
        error => {
          if (error.error && error.error.returnMessage) {
            AppComponent.addAlert(error.error.returnMessage.toString(), 'error');
            // this.scrollHelper.scrollToFirst('logo');
          }
          else
            AppComponent.addAlert(error.message, 'error');

          AppComponent.HideLoader();
        }
      );
    } else {
      this.invapi.CreatePartsDivisionMapping(prepCreate).subscribe(
        () => {
          AppComponent.loading = false;
          this.dialogRef.close(prepCreate);
        },
        error => {
          if (error.error?.returnMessage) {
            this.errormsg = error.error.returnMessage.toString();
            AppComponent.addAlert(this.errormsg, 'error');
          } else {
            this.errormsg = error.message;
            AppComponent.addAlert(this.errormsg, 'error');
          }
          AppComponent.HideLoader();
        }
      );
    }
  //   },
  //   error => {
  //     this.errormsg = error.message;
  //     AppComponent.addAlert(error.message, 'error');
  //     AppComponent.HideLoader();
  //   }
  // );
}

 setModel() {
  AppComponent.ShowLoader();

  const Id = { partID: this.data.equipementId };
 this.invapi.GetPartsQuantityByDivision(Id).subscribe(
  (success: any[]) => {
    if (success && success.length > 0) {
      success.forEach(item => {
        const matchIndex = this.divisionParts.controls.findIndex(ctrl =>
          ctrl['divisionID'].value == item.divisionID
        );

        if (matchIndex !== -1) {
          this.divisionParts.at(matchIndex).patchValue({
            quantity: item.quantity,
            selected: item.isChecked
          });
        }
      });
    }

    AppComponent.HideLoader();
  },
  error => {
    if (error.error?.returnMessage) {
      AppComponent.addAlert(error.error.returnMessage.toString(), 'error');
    } else {
      AppComponent.addAlert(error.message, 'error');
    }

    AppComponent.HideLoader();
  }
);
}

onUpdateClick() {
  this.showNewQty = true;
  this.divisionParts.controls.forEach(control => {
    const qtyCtrl = control.get('quantity');
    const newQtyCtrl = control.get('newQuantity');
    // copy old qty to new qty (same row)
    newQtyCtrl?.setValue(qtyCtrl?.value);
    control.get('quantity')?.disable(); 
    control.get('newQuantity')?.enable(); 
  });
}
 
isQuantityDisabled(dp: AbstractControl): boolean {
  return this.showNewQty || (dp.get('quantity')?.value > 0);
}

onCancelUpdateClick() {
  this.showNewQty = false;

  this.divisionParts.controls.forEach(control => {
    control.get('newQuantity')?.disable();
    control.get('quantity')?.enable();
  });
}
 
}
